import {INVENTORY_ITEMS} from '../constants/inventoryItems';

/**
 * РАЗОВАЯ НАГРАДА ЗА ИНТЕРЕС К ПОКУПКЕ.
 *
 * Покупка премиума и кристаллов пока не подключена. Когда игрок все же жмет
 * «Купить» в модалке товара, ему показывается модалка раннего доступа: покупка
 * появится в ближайшее время, а за проявленный интерес — разовый подарок.
 *
 * Награда своя на каждый тип товара и выдается ОДИН раз: полученные типы
 * лежат в профиле (User.receivedPurchaseInterestRewards) и приезжают на клиент
 * в auth. При повторном открытии модалка про награду уже не говорит.
 *
 * Конфиг общий для клиента и сервера: клиент им рисует награду, сервер — им же
 * начисляет (см. POST /api/purchase-interest-reward).
 */

export const PURCHASE_INTEREST_TYPES = {
  PREMIUM: 'premium',
  CRYSTALS: 'crystals',
};

export const PURCHASE_INTEREST_REWARDS = {
  [PURCHASE_INTEREST_TYPES.PREMIUM]: {
    itemType: INVENTORY_ITEMS.PREMIUM,
    value: 1,
    label: '1 день Премиума',
    iconSrc: '/img/icons/premium.png',
  },
  [PURCHASE_INTEREST_TYPES.CRYSTALS]: {
    itemType: INVENTORY_ITEMS.CRYSTALS,
    value: 100,
    label: '100 кристаллов',
    iconSrc: '/img/icons/crystal.png',
  },
};

export const getPurchaseInterestReward = (type) => PURCHASE_INTEREST_REWARDS[type] || null;

export const checkIfPurchaseInterestRewardReceived = (receivedTypes, type) =>
  Array.isArray(receivedTypes) && receivedTypes.includes(type);
